import React from "react"

export default function Home() {
  return <div>Hello world! I made a change on dev branch</div>
}
